module.exports = __webpack_public_path__ + "static/media/KOL-BASIS.f6661bb3.apng";